import styled, { keyframes } from "styled-components"

const shimmer = keyframes`
  0% {
    background-position: -50vw 0;
  }
  100% {
    background-position: 50vw 0;
  }
`

export default styled.div`
  position: relative;
  animation-name: ${shimmer};
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 100vw 104px;
  height: 100px;
`
